var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wizard-footer" }, [
    _c(
      "div",
      { staticClass: "footer-buttons" },
      [
        _vm.currentStep > 1
          ? _c(
              "b-button",
              {
                attrs: { variant: "outline-secondary" },
                on: {
                  click: function($event) {
                    return _vm.$emit("previous")
                  }
                }
              },
              [
                _c("feather-icon", {
                  attrs: { icon: "ChevronLeftIcon", size: "16" }
                }),
                _vm._v(" Atrás ")
              ],
              1
            )
          : _vm._e(),
        _c(
          "b-button",
          {
            attrs: { variant: "outline-secondary" },
            on: {
              click: function($event) {
                return _vm.$emit("cancel")
              }
            }
          },
          [_vm._v(" Cancelar ")]
        ),
        _vm.currentStep < 2
          ? _c(
              "b-button",
              {
                attrs: { variant: "primary", disabled: !_vm.canGoNext },
                on: {
                  click: function($event) {
                    return _vm.$emit("next")
                  }
                }
              },
              [
                _vm._v(" Siguiente "),
                _c("feather-icon", {
                  attrs: { icon: "ChevronRightIcon", size: "16" }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.currentStep === 2
          ? _c(
              "b-button",
              {
                attrs: { variant: "primary" },
                on: {
                  click: function($event) {
                    return _vm.$emit("create")
                  }
                }
              },
              [
                _vm._v(" Crear Documento "),
                _c("feather-icon", {
                  attrs: { icon: "FileTextIcon", size: "16" }
                })
              ],
              1
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }